
window.addEventListener("DOMContentLoaded", function(){

    var stripe_pay_form = document.querySelector('#stripe-pay');
    const html_spin = '<i class="fas fa-spinner fa-spin"></i>';
    var tmp_html_btn = '';

    if (stripe_pay_form) {
        var stripe = Stripe(window.stripe_key, { locale: document.documentElement.lang});

        const paymentRequest = stripe.paymentRequest({
          country: 'FR',
          currency: 'eur',
          total: {
            label: "",
            amount: paymentIntent.amount,
          },
          requestPayerName: true,
          requestPayerEmail: true,
        });

        const cardButton = stripe_pay_form.querySelector('#stripe-pay-card-button');
        const cardButtonLoading = stripe_pay_form.querySelector('#stripe-pay-card-button-loading');
        
        const error_el = stripe_pay_form.querySelector('#error-message');

        this.setTimeout(() => {
            cardButton.removeAttribute('disabled')
        },500)
        const appearance = { 
            theme: 'flat',
        };

        const clientSecret = paymentIntent.client_secret
        const options = {
            layout: {
                type: 'tabs',
                defaultCollapsed: false,
                radios: false,
                spacedAccordionItems: true
              },
              wallets: {
                applePay: 'auto',
                googlePay: 'auto'
              },
              hidePostalCode: true,
          };
          
        const elements = stripe.elements({ clientSecret, appearance });

        const prButton = elements.create('paymentRequestButton', {
          paymentRequest,
          style: {
            paymentRequestButton: {
              type: 'buy',        
              height: '54px',
            },
          },
        });
        (async () => {
          const result = await paymentRequest.canMakePayment();
          if (result) {
            prButton.mount('#payment-request-button');
          } else {
            document.getElementById('payment-request-button').style.display = 'none';
          }
        })();
                  
        const paymentElement = elements.create('payment', options);
        paymentElement.mount('#payment-element');

        cardButton.addEventListener('click', async (e) => {
          cardButtonLoading.innerHTML = html_spin;
          cardButton.setAttribute('disabled', '')
          error_el.classList.add('d-none')
          stripe.confirmPayment({
              elements,
              confirmParams: {
                return_url: this.window.location.href + "/success",
              },
            }).then(function(data){
              if(data.error)
              {
                  error_el.classList.remove('d-none');
                  cardButtonLoading.innerHTML = '';
                  cardButton.removeAttribute('disabled')
              }
              else
              {
                  var payment_intent_id = data.paymentIntent.id;
                  var hiddenInput = document.createElement('input');
                  hiddenInput.setAttribute('name', 'payment_intent_id');
                  hiddenInput.setAttribute('value', payment_intent_id);
                  stripe_pay_form.appendChild(hiddenInput);        
                  stripe_pay_form.submit();    
                  return;               
              }
              cardButtonLoading.innerHTML = '';
              cardButton.removeAttribute('disabled')
          });
      });
    }

});